module.exports = __webpack_public_path__ + "img/new4-img5.b9bd4b4a.png";